// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_tableWrapper__NTWS4 {
  max-width: calc(100vw - 24px);
  box-sizing: border-box;
  background: var(--mui-palette-primary-50);
  padding: 24px 16px;
  border-radius: 0.5rem;
  flex-grow: 1;
}

@media only screen and (max-width: 768px) {
  .table_tableWrapper__NTWS4 {
    max-width: 100vw;
    border-radius: 0;
    padding-top: 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/wrapper/table/index.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,yCAAyC;EACzC,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":[".tableWrapper {\n  max-width: calc(100vw - 24px);\n  box-sizing: border-box;\n  background: var(--mui-palette-primary-50);\n  padding: 24px 16px;\n  border-radius: 0.5rem;\n  flex-grow: 1;\n}\n\n@media only screen and (max-width: 768px) {\n  .tableWrapper {\n    max-width: 100vw;\n    border-radius: 0;\n    padding-top: 4px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableWrapper": `table_tableWrapper__NTWS4`
};
export default ___CSS_LOADER_EXPORT___;
